import React from "react";
import logo from "../../../../../assets/images/light-box.jpeg"

const LightBox = () => {
  return (
    <div><div className="media-display-layout">
      {logo && <img src={logo} alt="Logo" className="st-profile-logo"style={{width: "100%", height: "100%"}}/>}
    </div>
    <div className="slideshow" style={{color: "darkgray"}}>🎥 LightBox View</div>
    </div>
  );
};

export default LightBox;
